import { useMutation, useQueryClient } from "@tanstack/react-query";
import { rescheduleKeys } from "src/entities/reschedule";
import { appointmentKeys } from "src/entities/appointment/api/appointment.keys";
import { taskKeys } from "src/entities/task/api/task.keys";
import { scheduleKeys } from "src/entities/schedule/api/schedule.keys";
import { absenceApi } from "../service";
import { absenceKeys } from "../absence.keys";

/**
 * Deleting an absence frees the time it occupied, so `RescheduleFlagSweeper` un-flags whatever it
 * had displaced. Same invalidation set as create/update — this is the clearing direction of it.
 */
export function useDeleteAbsence() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) => absenceApi.remove(id).then((r) => r.data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: absenceKeys.lists() });
      queryClient.invalidateQueries({ queryKey: rescheduleKeys.all });
      queryClient.invalidateQueries({ queryKey: scheduleKeys.all });
      queryClient.invalidateQueries({ queryKey: appointmentKeys.all });
      queryClient.invalidateQueries({ queryKey: taskKeys.all });
    },
  });
}
